import * as actionTypes from "./actionTypes";
import * as types from "./types";

// post Extractor to api 
// - post has always (Data) payload (Request) to post to api
// - post can retrun success response - type success -200
// - post can Retrun Error response - type error - 500/400/403 - std. error response.

export const postMetaDataExtractorRequest = (payload: types.IMetaDataExtractor): types.PostMetaDataExtractorRequest => ({
    type: actionTypes.POST_METADATAEXTRACTOR_REQUEST,
    payload
});

export const postMetaDataExtractorSuccess = (payload: types.IPostMetaDataExtractorSuccessPayload): types.PostMetaDataExtractorSuccess => ({
    type: actionTypes.POST_METADATAEXTRACTOR_SUCCESS,
    payload
});

export const postMetaDataExtractorFailure = (payload: types.IPostMetaDataExtractorFailurePayload): types.PostMetaDataExtractorFailure => ({
    type: actionTypes.POST_METADATAEXTRACTOR_FAILURE,
    payload
});


//put Extractor to api
// PUT data target

export const putExtractorMetadataRequest = (
    tableId: string,
    payload: types.IExtractorMetadataPutReq
): types.PutExtractorMetadataRequest => ({
    type: actionTypes.PUT_METADATAEXTRACTOR_REQUEST,
    tableId,
    payload
});

export const putExtractorMetadataSuccess = (
    payload: types.IPutExtractorMetadataSuccessPayload
): types.PutExtractorMetadataSuccess => ({
    type: actionTypes.PUT_METADATAEXTRACTOR_SUCCESS,
    payload,
});

export const putExtractorMetadataFailure = (
    payload: types.IPutExtractorMetadataFailurePayload
): types.PutExtractorMetadataFailure => ({
    type: actionTypes.PUT_METADATAEXTRACTOR_FAILURE,
    payload,
});

//Get Extractor Table MetaData
export const fetchExtTableMetaDataReq = (params: types.IEXTTableMetaDataParams): types.FetchEXTTableMetaDataRequest => ({
    type: actionTypes.FETCH_EXTTABLEMETADATA_REQUEST,
    params,
});

export const fetchExtTableMetaDataSuccess = (payload: types.FetchEXTTableMetaDataSuccessPayload): types.FetchEXTTableMetaDataSuccess => ({
    type: actionTypes.FETCH_EXTTABLEMETADATA_SUCCESS,
    payload,
});

export const fetchExtTableMetaDataFailure = (payload: types.FetchEXTTableMetaDataFailurePayload): types.FetchEXTTableMetaDataFailure => ({
    type: actionTypes.FETCH_EXTTABLEMETADATA_FAILURE,
    payload,
}); 

//Get Foundry Extractor Table MetaData
export const fetchFoundryTableMetaDataReq = (params: types.IFoundryMetaDataParams): types.FetchFoundryTableMetaDataRequest => ({
    type: actionTypes.FETCH_FOUNDRYTABLEMETADATA_REQUEST,
    params,
});
export const fetchFoundryTableMetaDataSuccess = (payload: types.FetchFoundryTabMetaDataSuccessPayload): types.FetchFoundryMetaDataSuccess => ({
    type: actionTypes.FETCH_FOUNDRYTABLEMETADATA_SUCCESS,
    payload,
});

export const fetchFoundryTableMetaDataFailure = (payload: types.FetchEXTTableMetaDataFailurePayload): types.FetchFoundryMetaDataFailure => ({
    type: actionTypes.FETCH_FOUNDRYTABLEMETADATA_FAILURE,
    payload,
}); 